/*
	Created by G.Manukyan 
	gevorgmo@gmail.com
*/

var _menu_scroll_top=0;
var _team_index=0;
var lenis;
var can_scroll=false;
var _big_gallery_index=0;
var _big_gallery_images=[];
var _all_videos_count=0;
var _all_videos_loaded=0;


$(document).ready(function(){

	if (!Shopify.designMode) {
		lenis = new Lenis({
			autoRaf: true,
		});
		//lenis.on('scroll', (e) => {
		//	Scroll();
		//});
	} else {
		console.log("editing_mode");
		if(!$('body').hasClass('editing_mode'))$('body').addClass('editing_mode');
	}
	
	//////////////////////////////////////////////////////////////
	$(window).on('scroll', function(){
		Scroll();
	});
	//////////////////////////////////////////////////////////////
	 $(window).resize(function() {
		Resize();
	});
	//////////////////////////////////////////////////////////////
	if($(".video_cont")[0]){
		


		var _videos = document.querySelectorAll('.content_full_screen_video'); 
		_all_videos_count=_videos.length;
		for (var i = 0; i < _videos.length; ++i) {
			_videos[i].addEventListener("canplay", () => {
				_all_videos_loaded++;
				if(_all_videos_loaded==_all_videos_count){
					$(".content_full_screen_video").css('opacity','1');
					$(".loader").addClass('done');
					setTimeout(function(){
						can_scroll=true;
						Scroll();
					},600);
				}
			});	
		}
	} else{
		$(".loader").addClass('done');
		setTimeout(function(){
			can_scroll=true;
			Scroll();
		},600);
	}
		
	
	if($('.bg_preload').length)  loadAllBGImages($('.bg_preload'), function(){});
	
	setTimeout(function(){
		$('.header').removeClass('slow_up');
		$('.top_menu_button').removeClass('slow_up');
		_menu_scroll_top=$(window).scrollTop();	
		
		if($(".content_galleryteam")[0]){
			var hash = window.location.hash;
			if(hash.length>1){
				$('.content_galleryteam').trigger('to.owl.carousel', (parseInt(hash.substr(1))-1));	
			}
		}	
	},100);
	
	setTimeout(function(){
		if(lenis) lenis.resize();
	},2000);
	
 

	
	//////////////////////////////////////////////////////////////
	if($(".content_gallery_wrap")[0]){
		$('.content_gallery_wrap').each(function(){
			var _ths=$(this);
			var _ell={
				loop:(!_ths.hasClass('with_thumbs')?true:false),
				margin:0,
				items:1,
				dots:(!_ths.hasClass('with_thumbs')?true:false),
				nav:true,
				autoplay:(_ths.attr("data-autoplay")=="1"?true:false),
				mouseDrag:($(window).width()>980?false:true),
				touchDrag:($(window).width()>980?false:true),
				pullDrag:($(window).width()>980?false:true),
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
				autoplayTimeout:parseInt(_ths.attr("data-autoplaydelay"))*1000,
				//autoplayHoverPause:true
			};

			if(_ths.hasClass('content_galleryteam')) _ell.autoHeight=true;	

			_ths.owlCarousel(_ell);
			
			_ths.on('changed.owl.carousel', function(event) {
				if(_ths.hasClass('with_thumbs') &&  event.property.name=="position"){	
					var _ind=event.property.value ? event.property.value : 0;
					$('.gallery'+_ths.attr('data-gallery')).removeClass('active');
					$('.gallery'+_ths.attr('data-gallery')+".thumbs"+(_ind+1)).addClass('active');
					$('.content_gallery_thumbs'+$(this).attr('data-gallery')).trigger('to.owl.carousel', [_ind, 200, true]);	
				}	  
			});
		});
		
		$('body').on('click', '.content_gallery_thumb', function(evt) {
			evt.preventDefault();
			$('.content_gallery'+$(this).attr('data-gallery')).trigger('to.owl.carousel', [(parseInt($(this).attr('data-id'))-1),200,true]);	
			$('.content_gallery'+$(this).attr('data-gallery')).trigger('stop.owl.autoplay');
			return false;
		});
		setTimeout(function(){
			$('.content_gallery_thumbs').each(function(){
				if($(this).find('.content_gallery_thumb').length>4 || $(window).width()<=980){
					$(this).owlCarousel({
						margin:0,
						loop:false,
						mouseDrag:true,
						touchDrag:true,
						pullDrag:true,	
						autoWidth:true,	
						center:false,
						responsive:{
							0:{
								items:4
							},
							600:{
								items:5
							},
							800:{
								items:7
							},
							1150:{
								items:8
							}
						}
					})
				} else {
					$(this).addClass('static_gallary');
				}
			});
		},500);
	}
	
	//////////////////////////////////////////////////////////////
	if($('.clickable_slideshow')[0]){
		$('.clickable_slideshow').each(function(){
			_big_gallery_images.push($(this).attr('data-img'));
		});
	}	
	$('body').on('click', '.clickable_slideshow', function(evt) {
		evt.preventDefault();
		if(lenis) lenis.stop();
		var _img=$(this).attr('data-img');
		_big_gallery_index=_big_gallery_images.indexOf(_img);
		$('.big_image_gallery_image').css('background-image', 'url('+_big_gallery_images[_big_gallery_index]+')');	
		if(!$('.big_image_gallery').hasClass('open')) $('.big_image_gallery').addClass('open');	
		if(_big_gallery_images.length==1){
			$('.big_image_gallery_next').hide();
			$('.big_image_gallery_prev').hide();
		}
		return false;
	});
	//////////////////////////////////////////////////////////////
	$('body').on('click', '.big_image_gallery_close', function(evt) {
		evt.preventDefault();
		if(lenis) lenis.start();
		$('.big_image_gallery').removeClass('open');	
		return false;
	});
	//////////////////////////////////////////////////////////////
	$('body').on('click', '.big_image_gallery_next', function(evt) {
		evt.preventDefault();
		_big_gallery_index++;
		if(_big_gallery_index>=_big_gallery_images.length) _big_gallery_index=0;
		$('.big_image_gallery_image').css('background-image', 'url('+_big_gallery_images[_big_gallery_index]+')');	
		return false;
	});
	//////////////////////////////////////////////////////////////
	$('body').on('click', '.big_image_gallery_prev', function(evt) {
		evt.preventDefault();
		_big_gallery_index--;
		if(_big_gallery_index<0) _big_gallery_index=_big_gallery_images.length-1;
		$('.big_image_gallery_image').css('background-image', 'url('+_big_gallery_images[_big_gallery_index]+')');	
		return false;
	});
	//////////////////////////////////////////////////////////////
	$('body').on('click', '.team_itm_link', function(evt) {
		evt.preventDefault();
		if($(window).width()>980){
			let _cont=$(this).parent().find('.hidden_content');
			TeamPopUp(_cont);
			if(!$('.team_item_info_popup').hasClass('opened'))$('.team_item_info_popup').addClass('opened');
			if(lenis) lenis.stop();
		} else {
			if(!$("body").hasClass('team_gallery')) $("body").addClass('team_gallery');
			let _cont=$(this).parent().find('.hidden_content').attr('data-id');
			$('.content_galleryteam').trigger('to.owl.carousel', (parseInt(_cont)-1));	
		}
		return false;
	});
	//////////////////////////////////////////////////////////////	
	$('body').on('click', '.team_item_info_close', function(evt) {
		evt.preventDefault();
		$('.team_item_info_popup').removeClass('opened');
		$("body").removeClass('team_gallery');
		if(lenis) lenis.start();
		return false;
	});
	//////////////////////////////////////////////////////////////
	$('body').on('click', '.team_item_info_next', function(evt) {
		evt.preventDefault();
		_team_index++;
		if(_team_index>=$('.content_team_itm').length)_team_index=$('.content_team_itm').length;
		let _cont=$('.team_itm'+_team_index).find('.hidden_content');
		TeamPopUp(_cont);
		return false;
	});
	//////////////////////////////////////////////////////////////
	$('body').on('click', '.team_item_info_prev', function(evt) {
		evt.preventDefault();
		_team_index--;
		if(_team_index<=0)_team_index=1;
		let _cont=$('.team_itm'+_team_index).find('.hidden_content');
		TeamPopUp(_cont);
		return false;
	});
	//////////////////////////////////////////////////////////////
	$('body').on('click', '.top_menu_button', function(evt) {
		evt.preventDefault();
		if($(this).hasClass('opened')){
			$(this).removeClass('opened');
			$(".mobile_menu").removeClass('opened');
		} else {
			$(this).addClass('opened');
			if(!$(".mobile_menu").hasClass('opened'))$(".mobile_menu").addClass('opened');
		}
		return false;
	});
	//////////////////////////////////////////////////////////////	
	/*
		$('body').on('click', '.btn_project_load_more', function(evt) {
			evt.preventDefault();
			var _ind=0;
			$('.projectitmindx').each(function(){
				if(_ind<10 && $(this).hasClass('hdn_itm')){
					_ind++;
					$(this).removeClass('hdn_itm').addClass('_scroll-animate');
				}
			});
			if(lenis) lenis.resize();
			if($('.hdn_itm').length==0) $('.btn_project_load_more').hide();
			return false;
		});
	*/
	$('body').on('click', '.btn_project_load_more', function(evt) {
		evt.preventDefault();
		$('.projectitmindx').removeClass('hdn_itm').addClass('_scroll-animate');	
		$('.content_project_load_more').remove();
		if(lenis) lenis.resize();
		return false;
	});
	//////////////////////////////////////////////////////////////	
	




	Resize();
});



/////////////////////////////////////////////////////////////////////////////////////////////////////
function  Scroll(){
	if($(window).scrollTop()>=100){
		if(_menu_scroll_top>=$(window).scrollTop()){
			$('.header').removeClass('slow_up');
			$('.top_menu_button').removeClass('slow_up');
		} else {
			if(!$('.header').hasClass('slow_up')) $('.header').addClass('slow_up');
			if(!$('.top_menu_button').hasClass('slow_up')) $('.top_menu_button').addClass('slow_up');
		}
	} else {	
		$('.header').removeClass('slow_up');
		$('.top_menu_button').removeClass('slow_up');
	}
	
	if(($(window).scrollTop()>=200 && $(window).width()>980)  || ($(window).scrollTop()>=50 && $(window).width()<=980)){
		if(!$('body').hasClass('with_bg')) $('body').addClass('with_bg');
	} else {
		$('body').removeClass('with_bg');
	}
	
    $("._scroll-animate").each(function () {
        const elementTop = $(this).offset().top;
        const elementHeight = $(this).outerHeight();
        const windowBottom = $(window).scrollTop() + $(window).height();
        if (windowBottom >= (elementTop + elementHeight * 0.3) && can_scroll) {
            if(!$(this).hasClass('team_item_info_popup')) $(this).addClass("visible");
        }
    });
	
	_menu_scroll_top=$(window).scrollTop();
}
/////////////////////////////////////////////////////////////////////////////////////////////////////
function  Resize(){
	if($(".content_full_screen")[0]){
		$('.content_full_screen').css({"height":$(window).height()+"px"});
		
		if($(".content_full_screen_content")[0]){
			var _vw=$(window).width()/1920;
			var _vh=$(window).height()/1080;
			if(_vw>_vh){		
				$('.content_full_screen_content').css({"width":$(window).width()+"px", "height":(1080*_vw)+"px"});
			} else {
				$('.content_full_screen_content').css({"width":(1920*_vh)+"px", "height":$(window).height()+"px"});
			}
		}	

		$(".content_full_screen").each(function () {
			if($(this).hasClass('mob_mod') && $(window).width()>980){
				$(this).removeClass('desk_mod').removeClass('mob_mod').addClass('desk_mod');
				let _imgd=$(this).attr('data-img');
				let _imgm=$(this).attr('data-imgm');
				if(_imgd!=_imgm) $(this).css('background-image','url('+_imgd+')');
			} else if($(this).hasClass('desk_mod') && $(window).width()<=980){
				$(this).removeClass('desk_mod').removeClass('mob_mod').addClass('mob_mod');
				let _imgd=$(this).attr('data-img');
				let _imgm=$(this).attr('data-imgm');
				if(_imgd!=_imgm) $(this).css('background-image','url('+_imgm+')');
			}
		});	

	}	

	if($(".content_text_on_image")[0]){
		$(".content_text_on_image").each(function () {
			if($(this).hasClass('mob_mod') && $(window).width()>980){
				$(this).removeClass('desk_mod').removeClass('mob_mod').addClass('desk_mod');
				$(this).css('padding-bottom',$(this).attr('data-padding')+'%');
			} else if($(this).hasClass('desk_mod') && $(window).width()<=980){
				$(this).removeClass('desk_mod').removeClass('mob_mod').addClass('mob_mod');
				if($(this).attr('data-paddingm')!="0") $(this).css('padding-bottom',$(this).attr('data-paddingm')+'%');
			}
		});	
	}
	
	
	if($(".content_gallery_video_item")[0]){
		var _vw=$(window).width()/1920;
		var _vh=$(window).width()/1080;
		$('.content_gallery_video_item').css({"width":(1920*_vh)+"px", "height":$(window).height()+"px"});
	}	
	
	
	if($(".team_item_info_desc")[0]){
		$('.team_item_info_desc').css({"height":"auto"});	
		if($(".team_item_info_cont_right").height()>($(window).height()+20) && $(window).width()>980){
			$('.team_item_info_desc').css({"height":($(window).height()-$('.team_item_info_name').height()-$('.team_item_info_position').height()-60)+"px"});
		}
	}

	$('.video_cont').each(function(){
		if($(this).find(".video_m")[0]){
			if($(window).width()<=980 && $(window).width()<$(window).height()){
				$(this).find(".video_d").hide();
				$(this).find(".video_m").show();
			} else {
				$(this).find(".video_d").show();
				$(this).find(".video_m").hide();
			}
		}
	});	

}
/////////////////////////////////////////////////////////////////////////////////////////////////////
function loadImage(elem, _cb){
	var img = new Image();

    if(window.innerWidth < 640){
      if(elem.attr("data-srcm")){
        img.src = elem.attr("data-srcm");
      } else{
      	img.src = elem.attr("data-src");
      }
    }
    else if(window.innerWidth > 640 && window.innerWidth <= 980){
      if(elem.attr("data-srct")){
        img.src = elem.attr("data-srct");
      } else{
      	img.src = elem.attr("data-src");
      }
    } else{
      img.src = elem.attr("data-src");
    }
	
	img.onload = function() {
		elem.removeClass('bg_preload');
		elem.css('background-image','url('+img.src+')');
		_cb();
	}
}
/////////////////////////////////////////////////////////////////////////////////////////////////////
function loadAllBGImages(elems, _cb){
	if(elems.length>0){
		var _cont=elems.length;
		var _curr=0;
		elems.each(function(){
			loadImage($(this), function(){
				_curr++;
				if(_curr==_cont){
				 _cb(); 
				}
			});
		});
	} else {
		_cb();
	}
}
/////////////////////////////////////////////////////////////////////////////////////////////////////
function TeamPopUp(_cont){
	$('.team_item_info_desc').empty();
	$('.team_item_info_desc').html(_cont.html());
	$('.team_item_info_name').html(_cont.attr('data-name'));
	$('.team_item_info_position').html(_cont.attr('data-position'));
	$('.team_item_info_img').css('background-image','url('+_cont.attr('data-img')+')');
	if(_cont.attr('data-linkedin')!=""){
		$('.team_item_info_linkedin').attr('href',_cont.attr('data-linkedin'));
		$('.team_item_info_linkedin').css("visibility","visible");
	} else  {
		$('.team_item_info_linkedin').css("visibility","hidden");
	}
	
	$('.team_item_info_prev').css("visibility","visible");
	$('.team_item_info_next').css("visibility","visible");	
	if(_cont.attr('data-id')=="1"){
		$('.team_item_info_prev').css("visibility","hidden");
	}
	if(parseInt(_cont.attr('data-id'))>=$('.content_team_itm').length){
		$('.team_item_info_next').css("visibility","hidden");
	}
	_team_index=parseInt(_cont.attr('data-id'));
	
	$('.team_item_info_popup').removeClass('visible');
	
	setTimeout(function(){
		Resize();
		if(!$('.team_item_info_popup').hasClass('visible'))$('.team_item_info_popup').addClass('visible');
	},100);
}			